/* DNA Auto — instant navigation (Sept 2026).
   Makes moving around the store feel immediate:
   Shopify's HTML is not cacheable and Safari has no prerender, so: the moment a finger touches (or the mouse hovers)
   an internal link we fetch that page; on the tap we swap the page content in place (everything between the header
   and the footer, plus the product page's sticky buy bar), push the URL, run the new page's section scripts and re-run
   our own per-page setup (dnaMobile.onNavigate / dnaAssistant.onNavigate). Back/forward restore a snapshot. Any doubt
   → a normal navigation. Kill switch: localStorage.dna_instant = 'off' (or window.DNA_INSTANT = false). */
(function () {
  'use strict';
  if (!('fetch' in window) || !window.history || !window.history.pushState || !window.DOMParser) return;
  var off = false; try { off = localStorage.getItem('dna_instant') === 'off'; } catch (e) { /* ignore */ }
  if (off || window.DNA_INSTANT === false) return;
  try { history.scrollRestoration = 'manual'; } catch (e) { /* ignore */ }

  var current = location.href;
  var SKIP = /^\/(cart|checkout|checkouts|account|customer_authentication|customer_identity|apps|tools|admin|password|challenge|services|payments|wallets|\d+\/)/;
  var cache = {};                 // url → { at, promise }
  var TTL = 45000;
  var snapshots = {};             // url → { title, html, satc, scroll }
  var navigating = false;
  var loaded = {};                // script src → true (every script the page has executed so far)
  Array.prototype.slice.call(document.scripts).forEach(function (sc) { if (sc.src) loaded[sc.src] = true; });

  function eligible(a) {
    if (!a || a.target || a.hasAttribute('download') || a.hasAttribute('data-no-instant') || a.closest('[data-no-instant], form')) return null;
    var href = a.getAttribute('href'); if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return null;
    var u; try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || u.hash && u.pathname === location.pathname && u.search === location.search) return null;
    if (SKIP.test(u.pathname) || /\.(json|js|css|xml|pdf|zip|jpe?g|png|webp|gif|svg)$/i.test(u.pathname)) return null;
    if (u.pathname === '/account' || u.pathname.indexOf('/account/') === 0) return null;
    return u.href;
  }

  function getPage(url) {
    var c = cache[url];
    if (c && Date.now() - c.at < TTL) return c.promise;
    var p = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok || (r.headers.get('content-type') || '').indexOf('text/html') < 0 || (r.redirected && SKIP.test(new URL(r.url).pathname))) throw new Error('not html');
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var range = rangeOf(doc);
      if (!range) throw new Error('no range');
      warm(doc);
      return { doc: doc, url: url };
    });
    cache[url] = { at: Date.now(), promise: p };
    p.catch(function () { delete cache[url]; });
    return p;
  }

  // the block we swap: every body child after the header section and before the footer section
  function rangeOf(doc) {
    var body = doc.body; if (!body) return null;
    var kids = Array.prototype.slice.call(body.children);
    var start = -1, end = -1;
    for (var i = 0; i < kids.length; i++) {
      var id = kids[i].id || '';
      if (start < 0 && /^shopify-section-.*__header$/.test(id)) start = i;
      else if (start >= 0 && /^shopify-section-.*__footer$/.test(id)) { end = i; break; }
    }
    if (start < 0 || end < 0 || end <= start + 1) return null;
    if (!doc.getElementById('MainContent')) return null;
    return kids.slice(start + 1, end);
  }

  // stylesheets the new page needs → into <head> now; scripts + first pictures → preloaded
  function warm(doc) {
    doc.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (l) {
      var href = absolute(l.getAttribute('href'));
      if (document.querySelector('link[rel="stylesheet"][href="' + cssEsc(href) + '"]')) return;
      var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = href; n.setAttribute('data-dna-instant', '1'); document.head.appendChild(n);
    });
    doc.querySelectorAll('script[src]').forEach(function (s) {
      var src = absolute(s.getAttribute('src'));
      if (document.querySelector('script[src="' + cssEsc(src) + '"], link[rel="preload"][href="' + cssEsc(src) + '"]')) return;
      var n = document.createElement('link'); n.rel = 'preload'; n.as = 'script'; n.href = src; document.head.appendChild(n);
    });
    var imgs = doc.querySelectorAll('#MainContent img[src]');
    for (var i = 0; i < Math.min(4, imgs.length); i++) { var im = new Image(); im.src = absolute(imgs[i].getAttribute('src')); }
  }
  function absolute(u) { try { return new URL(u, location.href).href; } catch (e) { return u; } }
  function cssEsc(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  // Dawn's ModalDialog (product zoom, quick-add, pickup, popups) re-parents itself to the end of <body> on connect, so these
  // page-owned elements sit outside the section range and must travel with the page (left behind, they render unstyled).
  var MODALS = 'product-modal, quick-add-modal, quick-add-bulk-modal, pickup-availability-drawer, modal-dialog[id^="PopupModal-"], modal-dialog[id^="ProductModal-"]';
  function extras() { return Array.prototype.slice.call(document.body.children).filter(function (e) { return e.matches && e.matches(MODALS); }); }
  function snapshot(asUrl) {
    Array.prototype.forEach.call(document.querySelectorAll('.is-pressing'), function (e) { e.classList.remove('is-pressing'); e.style.removeProperty('--press'); e.style.removeProperty('--press-rgb'); });  // v2: never snapshot a press
    var range = rangeOf(document); if (!range) return;
    var satc = document.querySelector('.dna-satc');
    var nav = document.querySelector('.dna-mnav');
    snapshots[asUrl || location.href] = { title: document.title, nodes: range.map(function (n) { return n.cloneNode(true); }), satc: satc ? satc.cloneNode(true) : null, tpls: Array.prototype.slice.call(document.querySelectorAll('#dna-fit-tpl, #dna-pchips-tpl')).map(function (t) { return t.cloneNode(true); }), extras: extras().map(function (e) { return e.cloneNode(true); }), nav: nav ? nav.cloneNode(true) : null, scroll: window.scrollY };
  }

  // Oct 2 2026: the header is never swapped, so an open desktop mega menu / dropdown (Dawn <header-menu><details>) or the
  // search modal stayed open over the new page after a category was picked — close them on every navigation.
  function closeHeaderMenus() {
    Array.prototype.forEach.call(document.querySelectorAll('header-menu > details[open], .header__inline-menu details[open], details-disclosure > details[open]'), function (d) {
      var host = d.parentElement && d.parentElement.closest ? d.parentElement.closest('header-menu, details-disclosure') : null;
      try { if (host && typeof host.close === 'function') host.close(); else d.removeAttribute('open'); } catch (e) { d.removeAttribute('open'); }
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false');
    });
    var dm = document.querySelector('details-modal > details[open]');
    if (dm) { var m = dm.parentElement; try { if (typeof m.close === 'function') m.close(false); else dm.removeAttribute('open'); } catch (e) { dm.removeAttribute('open'); } }
    var ae = document.activeElement;
    if (ae && ae.closest && ae.closest('.header__inline-menu, details-modal') && typeof ae.blur === 'function') ae.blur();
  }

  function closeOverlays() {
    closeHeaderMenus();
    var hd = document.querySelector('header-drawer');
    var d = document.querySelector('header-drawer details[open]');
    if (d) { var done = false; try { if (hd && typeof hd.closeMenuDrawer === 'function') { hd.closeMenuDrawer({}, hd.querySelector('summary')); done = true; } } catch (e) { /* ignore */ } if (!done) d.removeAttribute('open'); }   // Dawn's HeaderDrawer ignores the call without a focus target
    // Oct 27 2026: whatever closed it, never leave the drawer's summary expanded — Dawn draws a 50 % grey film over the page
    // from .header__icon--menu[aria-expanded=true]::before, which is the "grey film on the categories page" Alex saw
    Array.prototype.forEach.call(document.querySelectorAll('header-drawer details'), function (dd) { if (!dd.open) { dd.classList.remove('menu-opening'); var sm = dd.querySelector(':scope > summary'); if (sm) sm.setAttribute('aria-expanded', 'false'); } });
    var cd = document.querySelector('cart-drawer.active'); if (cd && typeof cd.close === 'function') { try { cd.close(); } catch (e) { /* ignore */ } }
    try { if (window.dnaMobile && window.dnaMobile.closeAccount) window.dnaMobile.closeAccount(false); } catch (e) { /* ignore */ }
    try { if (window.dnaAssistant && window.dnaAssistant.close) window.dnaAssistant.close(false); } catch (e) { /* ignore */ }
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  }

  function swapIn(nodes, satc, tpls, title, url, scrollY, extra) {
    var cur = rangeOf(document); if (!cur) return false;
    var footer = cur[cur.length - 1].nextElementSibling;
    cur.forEach(function (n) { n.parentNode.removeChild(n); });
    extras().forEach(function (e) { e.parentNode.removeChild(e); });
    nodes.forEach(function (n) { document.body.insertBefore(n, footer); });
    (extra || []).forEach(function (e) { e.moved = true; document.body.appendChild(e); });   // already re-parented once: skip Dawn's connectedCallback move
    document.querySelectorAll('.dna-satc, #dna-fit-tpl, #dna-pchips-tpl').forEach(function (n) { n.parentNode.removeChild(n); });
    var nav = document.querySelector('.dna-mnav');
    var anchor = nav || document.querySelector('script[src*="dna-mobile.js"]');
    if (satc && anchor) anchor.parentNode.insertBefore(satc, anchor);
    tpls.forEach(function (t) { if (anchor) anchor.parentNode.insertBefore(t, anchor); });
    document.body.classList.toggle('dna-has-satc', !!satc);
    document.title = title;
    window.scrollTo(0, scrollY || 0);
    return true;
  }

  function runScripts(nodes) {
    nodes.forEach(function (root) {
      if (!root.querySelectorAll) return;
      root.querySelectorAll('script').forEach(function (s) {
        var type = (s.getAttribute('type') || 'text/javascript').toLowerCase();
        if (type.indexOf('json') >= 0 || type === 'speculationrules' || type === 'text/template') return;
        if (s.src) {
          var src = absolute(s.getAttribute('src'));
          if (loaded[src]) return;                                       // ran once already: its custom elements stay defined
          loaded[src] = true;
          var n = document.createElement('script'); n.src = src; n.async = false; n.setAttribute('data-dna-instant-src', '1');
          s.parentNode.replaceChild(n, s);
        } else {
          var m = document.createElement('script'); m.textContent = s.textContent; if (s.type) m.type = s.type;
          s.parentNode.replaceChild(m, s);
        }
      });
    });
  }

  function syncNav(doc) {
    var mine = document.querySelector('.dna-mnav'), theirs = doc.matches && doc.matches('.dna-mnav') ? doc : (doc.querySelector ? doc.querySelector('.dna-mnav') : null);
    if (!mine || !theirs || mine === theirs) return;
    mine.setAttribute('data-page', theirs.getAttribute('data-page') || '');
    var a = mine.querySelectorAll('a, button'), b = theirs.querySelectorAll('a, button');
    for (var i = 0; i < a.length && i < b.length; i++) { a[i].classList.toggle('is-active', b[i].classList.contains('is-active')); if (b[i].getAttribute('aria-current')) a[i].setAttribute('aria-current', 'page'); else a[i].removeAttribute('aria-current'); }
  }

  // the header is never swapped, so its "current section" underline would stay on the previous page's menu item
  function syncHeaderActive() {
    var path = location.pathname.replace(/\/$/, '') || '/';
    Array.prototype.forEach.call(document.querySelectorAll('.header__inline-menu .list-menu--inline > li'), function (li) {
      var on = false;
      Array.prototype.forEach.call(li.querySelectorAll('a[href]'), function (a) {
        var p = ''; try { p = new URL(a.href, location.href).pathname.replace(/\/$/, '') || '/'; } catch (e) { /* ignore */ }
        var cur = p === path;
        if (a.classList.contains('mega-menu__link') || a.classList.contains('header__menu-item')) {
          a.classList.toggle('mega-menu__link--active', cur && a.classList.contains('mega-menu__link'));
          if (cur) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
        }
        if (cur) on = true;
      });
      var span = li.querySelector('summary > span, a.header__menu-item > span');
      if (span) span.classList.toggle('header__active-menu-item', on);
    });
  }

  function afterNavigate(doc) {
    syncNav(doc);
    try { syncHeaderActive(); } catch (e) { /* ignore */ }
    try { var pill = document.querySelector('.dna-msearch__form input[name="q"]'), np = doc.querySelector && doc.querySelector('.dna-msearch__form input[name="q"]'); if (pill && np && pill !== np) pill.value = np.value; } catch (e) { /* ignore */ }
    document.body.classList.toggle('dna-subpage', (document.querySelector('.dna-mnav') || {}).getAttribute && (document.querySelector('.dna-mnav').getAttribute('data-page') !== 'index'));
    try { if (window.dnaMobile && window.dnaMobile.onNavigate) window.dnaMobile.onNavigate(); } catch (e) { /* ignore */ }
    try { if (window.dnaAssistant && window.dnaAssistant.onNavigate) window.dnaAssistant.onNavigate(); } catch (e) { /* ignore */ }
    try { if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.page) window.ShopifyAnalytics.lib.page(); } catch (e) { /* ignore */ }
    document.dispatchEvent(new CustomEvent('dna:navigate', { detail: { url: location.href } }));
  }

  function go(url) {
    if (navigating) return;
    navigating = true;
    document.documentElement.classList.add('dna-instant-loading');
    var timer = setTimeout(function () { if (navigating) { navigating = false; location.href = url; } }, 4000);   // slow fetch → real navigation
    getPage(url).then(function (page) {
      if (!navigating) return;
      clearTimeout(timer);
      var doc = page.doc, range = rangeOf(doc);
      snapshot();
      closeOverlays();
      var nodes = range.map(function (n) { return document.adoptNode(n); });
      var satc = doc.querySelector('.dna-satc'); if (satc) satc = document.adoptNode(satc);
      var tpls = Array.prototype.slice.call(doc.querySelectorAll('#dna-fit-tpl, #dna-pchips-tpl')).map(function (t) { return document.adoptNode(t); });
      history.pushState({ dnaInstant: 1, depth: depth() + 1, searchParams: facetsPrev() }, '', url);
      if (!swapIn(nodes, satc, tpls, doc.title || document.title, url, 0)) { location.href = url; return; }
      current = location.href;
      runScripts(nodes);
      afterNavigate(doc);
      delete cache[url];
      navigating = false;
      document.documentElement.classList.remove('dna-instant-loading');
    }).catch(function () {
      clearTimeout(timer);
      navigating = false;
      document.documentElement.classList.remove('dna-instant-loading');
      location.href = url;
    });
  }

  // ---- wiring
  var lastTouch = 0;
  function prefetchFrom(ev) {
    var a = ev.target.closest && ev.target.closest('a[href]'); if (!a) return;
    var url = eligible(a); if (!url || url === location.href) return;
    getPage(url).catch(function () { /* ignore */ });
  }
  {
    document.addEventListener('touchstart', function (ev) { lastTouch = Date.now(); prefetchFrom(ev); }, { passive: true, capture: true });
    document.addEventListener('mouseover', function (ev) { if (Date.now() - lastTouch > 800) prefetchFrom(ev); }, { passive: true, capture: true });
    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target.closest && ev.target.closest('a[href]'); if (!a) return;
      if (a.closest('.header__inline-menu, details-modal')) closeHeaderMenus();       // close the menu the moment a category is picked
      var url = eligible(a); if (!url) return;
      if (url === location.href) { ev.preventDefault(); closeOverlays(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      ev.preventDefault();
      go(url);
    });
    // capture phase: at the target, capturing listeners run first (modern browsers), so a pjax history entry can be
    // restored before Dawn's facets popstate handler (which would otherwise fetch the collection grid for a stale URL)
    window.addEventListener('popstate', function (ev) {
      if (location.href.split('#')[0] === current.split('#')[0]) return;   // same page: a sheet closed or an in-page anchor moved
      var snap = snapshots[location.href];
      if (!snap) { if (ev.state && ev.state.dnaInstant) { ev.stopImmediatePropagation(); location.reload(); } return; }
      ev.stopImmediatePropagation();
      if (current !== location.href) snapshot(current);
      closeOverlays();
      var nodes = snap.nodes.map(function (n) { return n.cloneNode(true); });
      if (!swapIn(nodes, snap.satc ? snap.satc.cloneNode(true) : null, snap.tpls.map(function (t) { return t.cloneNode(true); }), snap.title, location.href, snap.scroll, snap.extras.map(function (e) { return e.cloneNode(true); }))) { location.reload(); return; }
      current = location.href;
      runScripts(nodes);
      afterNavigate(snap.nav || document);
    }, true);
    try { history.replaceState({ dnaInstant: 1, depth: 0, searchParams: facetsPrev() }, '', location.href); } catch (e) { /* ignore */ }
    // other scripts (Dawn's filters, pagination) push their own entries: keep `current` and the depth counter in step
    var _push = history.pushState, _replace = history.replaceState;
    history.pushState = function (state) {
      var d = depth(), r = _push.apply(this, arguments);
      if (state && typeof state === 'object' && (!('depth' in state) || !('searchParams' in state))) {
        var fill = {}; if (!('depth' in state)) fill.depth = d; if (!('searchParams' in state)) fill.searchParams = facetsPrev();
        try { _replace.call(history, Object.assign({}, state, fill), '', location.href); } catch (e) { /* ignore */ }
      }
      current = location.href; return r;
    };
    history.replaceState = function () { var r = _replace.apply(this, arguments); current = location.href; return r; };
  }
  function depth() { return (history.state && history.state.depth) || 0; }
  // Dawn's facets.js re-renders the collection grid on every popstate whose state.searchParams differs from the last
  // params it rendered; giving pjax entries that same value keeps it idle (it would fetch "?section_id=..&undefined").
  function facetsPrev() { try { return typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm.searchParamsPrev : undefined; } catch (e) { return undefined; } }
  window.dnaInstant = { pjax: true, go: go, closeMenus: closeHeaderMenus, prefetch: function (url) { return getPage(url); }, depth: depth };
})();
